import React from 'react';
import { useNotifications } from '../context/NotificationContext';

const COLORS = {
  new:  { bg: '#f0fdf4', border: '#86efac', text: '#15803d', bar: '#22c55e' },
  warn: { bg: '#fffbeb', border: '#fde68a', text: '#92400e', bar: '#f59e0b' },
};

export default function ToastOverlay() {
  const { toasts, dismissToast } = useNotifications();
  if (!toasts.length) return null;

  return (
    <div style={{
      position: 'fixed', top: 20, right: 20, zIndex: 99999,
      display: 'flex', flexDirection: 'column', gap: 10,
      maxWidth: 360, width: 'calc(100vw - 40px)',
      pointerEvents: 'none',
    }}>
      {toasts.map(t => {
        const c = COLORS[t.type] || COLORS.new;
        return (
          <div key={t.id} style={{
            background: c.bg, border: `1.5px solid ${c.border}`,
            borderRadius: 14, overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(0,0,0,0.14)',
            animation: 'toastIn 0.3s cubic-bezier(0.34,1.56,0.64,1)',
            pointerEvents: 'all',
          }}>
            {/* Progress bar */}
            <div style={{
              height: 3, background: c.bar,
              animation: 'toastProgress 8s linear forwards',
              transformOrigin: 'left',
            }} />

            <div style={{ padding: '12px 14px', display: 'flex', alignItems: 'flex-start', gap: 10 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 800, color: c.text, marginBottom: 2 }}>
                  {t.title}
                </div>
                {t.body && (
                  <div style={{ fontSize: 12, color: c.text, opacity: 0.8, lineHeight: 1.45 }}>
                    {t.body}
                  </div>
                )}
              </div>
              <button
                onClick={() => dismissToast(t.id)}
                style={{
                  background: 'none', border: 'none', cursor: 'pointer',
                  padding: '2px 4px', fontSize: 14, color: c.text,
                  opacity: 0.45, lineHeight: 1, flexShrink: 0,
                  marginTop: 1,
                }}
              >✕</button>
            </div>
          </div>
        );
      })}

      <style>{`
        @keyframes toastIn {
          from { opacity: 0; transform: translateX(60px) scale(0.92); }
          to   { opacity: 1; transform: translateX(0) scale(1); }
        }
        @keyframes toastProgress {
          from { transform: scaleX(1); }
          to   { transform: scaleX(0); }
        }
      `}</style>
    </div>
  );
}
